/**
 * DisplayCurrency — formats a number using the store's active currency.
 *
 * Currency and symbol come from the public store settings (SWR: 'settings/public').
 * Falls back to INR if settings haven't loaded yet.
 *
 * Usage: <DisplayCurrency number={1299} />
 */
import useSWR from 'swr'

const LOCALE_MAP = {
  INR: 'en-IN',
  USD: 'en-US',
  AUD: 'en-AU',
  GBP: 'en-GB',
  EUR: 'de-DE',
  CAD: 'en-CA',
  SGD: 'en-SG',
  AED: 'ar-AE',
  SAR: 'ar-SA',
  NZD: 'en-NZ',
  MYR: 'ms-MY',
  LKR: 'si-LK',
  BDT: 'bn-BD',
  PKR: 'ur-PK',
  JPY: 'ja-JP',
  CNY: 'zh-CN',
  QAR: 'ar-QA',
  KWD: 'ar-KW',
  OMR: 'ar-OM',
  BHD: 'ar-BH',
}

const DisplayCurrency = ({ number, compact = false }) => {
  const { data: publicSettings } = useSWR('settings/public')
  const currency = publicSettings?.currency || 'INR'
  const locale = LOCALE_MAP[currency] || 'en-IN'

  if (number == null) return null

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: currency === 'JPY' || currency === 'BDT' ? 0 : 0,
      notation: compact ? 'compact' : 'standard',
    }).format(number)
  } catch {
    // Fallback if currency code is unrecognised
    const sym = publicSettings?.currency_symbol || '₹'
    return `${sym}${Number(number).toLocaleString()}`
  }
}

export default DisplayCurrency
